import styled from 'styled-components';
import { TabList as DefTabList } from 'react-tabs';

export const TabList = styled(DefTabList)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(60px, 1fr));
  border-bottom: 1px solid ${({ theme }) => theme.getColor('shark2')};
`;
